<template>
  <div class="coupons">
		<div class="coupons-grids text-center">
			<div class="row">
				<div class="col-md-3 w3layouts_mail_grid_left pr-3">
					<div class="w3layouts_mail_grid_left1 hvr-radial-out fl-right">
						<i class="fa fa-headphones" aria-hidden="true"></i>
					</div>
					<div class="w3layouts_mail_grid_left2 dir-rtl pr-2">
						<h3>پشتیبانی</h3>
						<p>در 24 ساعت شبانه روز 7روز هفته در کنار شمائیم</p>
					</div>
				</div>
				<div class="col-md-3 w3layouts_mail_grid_left pr-3">
					<div class="w3layouts_mail_grid_left1 hvr-radial-out fl-right">
						<i class="fa fa-gift" aria-hidden="true"></i>
					</div>
					<div class="w3layouts_mail_grid_left2 dir-rtl pr-2">
						<h3>هدیه تراکنش</h3>
						<p>باخریدشارژ واینترنت از راداَپ ماهانه هدیه بگیرید</p>
					</div>
				</div>
				<div class="col-md-3 w3layouts_mail_grid_left pr-3">
					<div class="w3layouts_mail_grid_left1 hvr-radial-out fl-right">
						<i class="fa fa-truck" aria-hidden="true"></i>
					</div>
					<div class="w3layouts_mail_grid_left2 dir-rtl pr-2">
						<h3>ارسال رایگان</h3>
						<p> سوپر مارکت 30 دقیقه، رستوران 45 دقیقه حداکثر تا رسیدن به دست شما</p>
					</div>
				</div>
				<div class="col-md-3 w3layouts_mail_grid_left pr-3">
					<div class="w3layouts_mail_grid_left1 hvr-radial-out fl-right">
						<i class="fa fa-calculator" aria-hidden="true"></i>
					</div>
					<div class="w3layouts_mail_grid_left2 dir-rtl pr-2">
						<h3>خرید=درآمد</h3>
						<p>تقسیم 50%سود شرکت با شما بعد از عضویت و خرید دوستانتان
						</p>	
					</div>
				</div>
				<div class="clearfix"> </div>
			</div>
		</div>
</div>
</template>

<script>
export default {
name:"GridTemplate"
}
</script>

<style scoped>
.row {
    --bs-gutter-x: 0 !important;
}
.w3layouts_mail_grid_left1 {
	border-radius: 5px;
	}
</style>